<template>
  <div class="container">
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>服务设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="between">
      <div class="left_con">
        <div class="left_inner_con">
          <el-input size="mini"
                    style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                    placeholder="输入关键字进行过滤"
                    v-model="filterText">
          </el-input>
          <el-tree
            :data="orgList"
            :props="treeProps"
            @check="handleCheckChange"
            :highlight-current="true"
            node-key="id"
            show-checkbox
            :filter-node-method="filterNode"
            ref="tree">
          </el-tree>
        </div>
        <div class="left_inner_con">
          <el-input size="mini"
                    style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                    placeholder="输入关键字进行过滤"
                    v-model="serveTypeFilterText">
          </el-input>
          <el-tree
            :data="serviceTypeList"
            :props="serviceTypeProps"
            @node-click="serviceTypeHandleNodeClick"
            :highlight-current="true"
            node-key="id"
            :filter-node-method="serveTypeFilterNode"
            default-expand-all
            draggable
            ref="serviceTree"
            @node-drop="handleDrop"
            :allow-drop="allowDrop">
          </el-tree>
        </div>
      </div>
      <div class="table_container" style="border: 0 solid rgb(222,222,222);margin: 10px 0">
        <el-button size="mini"  plain @click="showServeTypeDialog(1)"
                   v-if="authorities.includes('system.service.type.new')">添加服务分类</el-button>
        <el-button size="mini"  plain @click="showServeTypeDialog(2)"
                   v-if="authorities.includes('system.service.type.update')">修改服务分类</el-button>
        <el-button size="mini"  plain @click="deleteServeTypeBox"
                   v-if="authorities.includes('system.service.type.delete')">删除服务分类</el-button>
        <el-button size="mini"  plain :disabled="serviceIsDisplay" @click="showServiceDialog(1,null)"
                   v-if="authorities.includes('system.service.new')">添加服务</el-button>
        <el-table height="550px" :data="serveList" fit border stripe="stripe"
                  :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  :row-style="{height: '0'}" >
          <el-table-column
            align="center"
            prop="userName"
            fixed="fixed"
            label="操作" width="100">
            <template slot-scope="scope">
              <div style="display: flex;justify-content: space-evenly">
                <el-link type="primary" v-if="authorities.includes('system.service.update')" icon="el-icon-edit"
                         @click="showServiceDialog(2,scope.row)"></el-link>
                <el-link type="danger" v-if="authorities.includes('system.service.delete')" icon="el-icon-delete"
                         @click="deleteServiceBox(scope.row)"></el-link>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="serviceName"
            fixed="fixed"
            label="服务名称" width="200">
          </el-table-column>
          <el-table-column
            align="center"
            prop="serviceTypeName"
            label="服务分类" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="isPackage"
            :formatter="packageFormatter"
            label="是否散客可用" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="price"
            label="标准价格" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="priceBronze"
            label="大众会员价格" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="priceGold"
            label="黄金会员价格" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="pricePlatinum"
            label="铂金会员价格" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="priceDiamond"
            label="钻石会员价格" width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="salaryRate"
            label="提成" width="100">
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 添加分类 -->
    <el-dialog
      :title="title"
      :visible.sync="serveTypeDialogVisible"
      width="30%"
      style="position: absolute"
      @close="closeDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <span>
            分类名称：
            <el-input v-model="footServeType.serviceTypeName" placeholder="请输入内容" size="mini" style="width: 300px;padding-bottom: 10px"></el-input>
      </span>
      <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="cancel">取 消</el-button>
            <el-button size="mini" @click="createServiceType">确 定</el-button>
          </span>
    </el-dialog>

    <!--  添加服务 -->
    <el-dialog
      :title="service_title"
      :visible.sync="serviceDialogVisible"
      width="60%"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style="height: 300px;padding: 20px 0;display: flex;justify-content: space-between;flex-wrap: wrap;align-items: start">
        <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;width: 50%;height: 50px;">
            服务名称：
            <el-input v-model="footService.serviceName" @change="checkServiceName" placeholder="请输入内容" size="mini" style="width: 300px"></el-input>
        </div>
        <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;width: 50%;height: 50px;">
            所属分类：
            <el-input v-model="footService.serviceTypeName"  placeholder="请输入内容" disabled size="mini" style="width: 300px;"></el-input>
        </div>
        <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;width: 50%;height: 50px;">
          标准价格：<el-input v-model="footService.price" placeholder="请输入内容" size="mini" style="width: 300px;"
                         onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
        </div>
        <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;width: 50%;height: 50px;">
          大众会员价格：
          <el-input v-model="footService.priceBronze" placeholder="请输入内容" size="mini" style="width: 300px;"
                    onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
        </div>
        <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;width: 50%;height: 50px;">
          黄金会员价格：
          <el-input v-model="footService.priceGold" placeholder="请输入内容" size="mini" style="width: 300px;"
                    onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
        </div>
        <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;width: 50%;height: 50px;">
          铂金会员价格：
          <el-input v-model="footService.pricePlatinum" placeholder="请输入内容" size="mini" style="width: 300px;"
                    onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
        </div>
        <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;width: 50%;height: 50px;">
          钻石会员价格：
          <el-input v-model="footService.priceDiamond" placeholder="请输入内容" size="mini" style="width: 300px;"
                    onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
        </div>
        <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;width: 50%;height: 50px;">
          提成（%）：
          <el-input v-model="footService.salaryRate" placeholder="请输入内容" size="mini" style="width: 300px;"
                    onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
        </div>
        <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;width: 50%;height: 50px;">
          固定提成：
          <el-input v-model="footService.fixedRate" placeholder="请输入内容" size="mini" style="width: 300px;"
                    onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
        </div>
        <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;width: 50%;height: 50px;">
          散客是否可用：
          <el-radio-group v-model="footService.isPackage" @change="changeIsPackage">
            <el-radio  :label="1">是</el-radio>
            <el-radio  :label="2">否</el-radio>
          </el-radio-group>
        </div>
        <div class="input_item_con" style="display: flex;align-items: center;justify-content: flex-start;width: 50%;height: 50px;">
          是否显示直径：
          <el-radio-group v-model="footService.isShowDia" @change="changeIsShowDia">
            <el-radio  :label="1" >是</el-radio>
            <el-radio  :label="2" >否</el-radio>
          </el-radio-group>
        </div>
        <div class="input_item_con" style="display: flex;justify-content: space-around; justify-items: center;
            align-items: center; width: 50%;height: 50px;">
          <div>
            <el-checkbox v-model="footService.isCksy" @change="setIsNumTicket">是否次卡会员可用</el-checkbox>
          </div>
          <div>
            <span>次数：</span>
            <el-input v-model="footService.cardNum" :disabled="footService.isCksy === false" size="mini" style="width: 30%;"
                      onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
          </div>

        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="serviceCancel">取 消</el-button>
        <el-button size="mini" @click="createService">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      orgId:'',
      orgLevel:'',
      authorities:'',
      orgList: [],
      userId: '',
      filterText: '',
      serveTypeFilterText:'',
      treeProps: {
        label: 'orgName',
        children: 'children'
      },
      serviceTypeList:[],
      serviceTypeProps:{
        label: 'serviceTypeName',
        children: 'children'
      },
      isShow: true,
      isShow_:true,
      serveList:[],
      loadServeTypeOrgId:'',
      title:'',
      serveTypeDialogVisible: false,
      footServeType:{
        id:'',
        orgIds:[],
        serviceTypeName:'',
        parentId:'',
        parentTypeName:'',
        orderNo:'',
        creator:'',
        modifier:''
      },
      operateType:'',
      serveTypeData:'',
      //######################以下是服务的内容
      service_title:'',
      serviceDialogVisible:false,
      footService:{
        id:'',
        orgId:'',
        orgIds:[],
        serviceName:'',
        oldServiceName:'',
        serviceTypeId:'',
        isPackage:2,
        price:'',
        priceBronze:'',
        priceGold:'',
        pricePlatinum:'',
        priceDiamond:'',
        salaryRate:'',
        fixedRate:'',
        serviceTypeName: '',
        creator: '',
        modifier:'',
        isShowDia:2,
        cardNum:0,
        isNumTicket:2,
        isCksy:false
      },
      serviceIsDisplay:true,
      serviceOperateType:'',
      isPackageText:[
        {isPackage:1,name:'是'},
        {isPackage:2,name:'否'}
      ],
      deleteServiceId:'',
      deleteServiceName:'',
      oldServiceTypeName:'',
      existName:false,
      createServiceDoubleClick:false,
      createServiceTypeDoubleClick:false

    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    serveTypeFilterText(val) {
      this.$refs.serviceTree.filter(val);
    }
  },
  methods:{
    setIsNumTicket(){
      if (this.footService.isCksy){
        this.footService.isNumTicket = 1;
      } else {
        this.footService.isNumTicket = 2;
      }
    },
    async loadOrg(){
      const {data:res} = await this.$http.get(`orgList/orgId/${this.orgId}`);
      this.orgList = [res.data];
    },
    async handleCheckChange(data) {
      this.isShow = true;
      this.isShow_ = true;
      this.loadServeTypeOrgId = data.id;
      this.orgId = data.id;
      this.orgLevel = data.level;
      this.footServeType.orgId = data.id;
      this.footServeType.orgIds = this.$refs.tree.getCheckedKeys();
      this.footService.orgIds = this.$refs.tree.getCheckedKeys();
      if (this.footServeType.orgIds.length === 0){
        this.serviceTypeList = [];
        this.serveList = [];
        this.serviceIsDisplay = true;
      }
      if (this.footServeType.orgIds.length > 0){
        //加载服务分类
        const {data:res} = await this.$http.get(`footServeType/orgId/${this.footServeType.orgIds[0]}`);
        if (res.code === 200){
          this.serviceTypeList = res.data;
        }
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    serveTypeFilterNode(value, data) {
      if (!value) return true;
      return data.serviceTypeName.indexOf(value) !== -1;
    },
    async serviceTypeHandleNodeClick(data){
      this.isShow = false;
      if (this.footServeType.orgIds.length > 0){
        this.isShow_ = true;
      }
      if (this.footServeType.orgIds.length === 1){
        this.isShow_ = false;
      }
      // 1表示添加新分类,所以选中的id作为新添加分类的parentId
      if (this.operateType === 1){
        this.footServeType.parentId = data.id;
        this.footServeType.parentTypeName = data.serviceTypeName;
      }
      this.serveTypeData = data;
      this.oldServiceTypeName = data.serviceTypeName;
      if (data.parentId !== '' && data.parentId !== 0){
        this.isShow = true;
        this.serviceIsDisplay = false;
      } else {
        this.serviceIsDisplay = true;
      }

      await this.loadService();
    },
    async showServeTypeDialog(val){
      this.operateType = val;
      if (val === 1){
        this.title = "添加分类";
      } else {
        this.title = "修改分类";
        this.footServeType.id = this.serveTypeData.id;
        this.footServeType.orgId = this.serveTypeData.orgId;
        this.footServeType.serviceTypeName = this.serveTypeData.serviceTypeName;
        this.footServeType.orderNo = this.serveTypeData.orderNo;
      }
      this.serveTypeDialogVisible = true;
    },
    cancel(){
      this.serveTypeDialogVisible = false;
    },
    async createServiceType(){

      if (this.footServeType.serviceTypeName === ''){
        return this.$message.warning("请填写服务分类名称！");
      }

      const {data:res1} = await this.$http.get(`/footServeType/name/${this.footServeType.serviceTypeName}`);
      if (res1.code === 200){
        return this.$message.warning("该分类名称已经存在！")
      }

      if (this.operateType === 1){
        //表示新增
        this.footServeType.creator = this.userId;
        this.createServiceTypeDoubleClick = true;
        const {data:res} = await this.$http.post(`footServeType`,this.footServeType);
        if (res.code === 200){
          this.serviceTypeList = res.data;
          this.createServiceTypeDoubleClick = false;
        } else {
          this.createServiceTypeDoubleClick = false;
        }
      }
      if (this.operateType === 2){
        //表示更新
        this.footServeType.modifier = this.userId;
        this.createServiceTypeDoubleClick = true;
        const {data:res} = await this.$http.put(`footServeType/orgId/${this.orgId}/newServiceTypeName/${this.footServeType.serviceTypeName}/oldServiceTypeName/${this.oldServiceTypeName}/modifier/${this.userId}`);
        if (res.code === 200){
          this.serviceTypeList = res.data;
          this.createServiceTypeDoubleClick = false;
        } else {
          this.createServiceTypeDoubleClick = false;
        }
      }
      this.clear();
      this.serveTypeDialogVisible = false;
    },
    deleteServeTypeBox(){
      this.$confirm('此操作将永久删除该分类, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.deleteServeType();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    async deleteServeType(){
      const {data:res} = await this.$http.delete(`/footServeType/orgId/${this.serveTypeData.orgId}/orgLevel/${this.orgLevel}/footServiceName/${this.serveTypeData.serviceTypeName}`);
      if (res.code === 200){
        this.$message.success(res.msg);
        this.serviceTypeList = res.data;
      } else {
        this.$message.success(res.msg);
      }
    },
    closeDialog(){
      this.clear();
    },
    clear(){
      this.serveTypeDialogVisible = false;
      this.footServeType.serviceTypeName = '';
      this.footServeType.orderNo = '';
    },
    showServiceDialog(val, data){
      this.serviceOperateType = val;
      if (val === 1){
        this.service_title = '添加服务';
        this.footService.serviceTypeName = this.serveTypeData.serviceTypeName;
        this.footService.serviceTypeId = this.serveTypeData.id;
        this.footService.orgId = this.serveTypeData.orgId;
        this.footService.creator = this.userId;
        this.footService.serviceName = '';
        this.footService.price = '';
        this.footService.priceBronze = '';
        this.footService.priceGold = '';
        this.footService.pricePlatinum = '';
        this.footService.priceDiamond = '';
        this.footService.isPackage = '';
        this.footService.salaryRate = '';
      } else {
        this.service_title = '修改服务';
        this.footService.serviceTypeName = data.serviceTypeName;
        this.footService.serviceTypeId = data.serviceTypeId;
        this.footService.orgId = data.orgId;
        this.footService.price = data.price;
        this.footService.priceBronze = data.priceBronze;
        this.footService.priceGold = data.priceGold;
        this.footService.pricePlatinum = data.pricePlatinum;
        this.footService.priceDiamond = data.priceDiamond;
        this.footService.isPackage = data.isPackage;
        this.footService.salaryRate = data.salaryRate;
        this.footService.serviceName = data.serviceName;
        this.footService.oldServiceName = data.serviceName;
        this.footService.id = data.id;
        this.footService.isShowDia = data.isShowDia;
        this.footService.modifier = this.userId;
        this.footService.fixedRate = data.fixedRate;
        this.footService.cardNum = data.cardNum;
        if (data.isNumTicket === 1){
          this.footService.isCksy = true;
        }
        if (data.isNumTicket === 2){
          this.footService.isCksy = false;
        }

      }
      this.serviceDialogVisible = true;
    },
    changeIsPackage(val){
      this.footService.isPackage = val;
    },
    changeIsShowDia(val){
      this.footService.isShowDia = val;
    },
    async createService(){

      if (this.existName === true){
        return this.$message.warning("该服务名称已经存在！")
      }
      if (this.footService.isCksy && this.footService.cardNum === 0){
        return this.$message.warning("请填写次数！")
      }

      //新增
      if (this.serviceOperateType === 1){
        this.createServiceDoubleClick = true;
        const {data:res} = await this.$http.post(`footService`,this.footService);
        if (res.code === 200){
          this.$message.success(res.msg);
          this.createServiceDoubleClick = false;
        }else {
          this.createServiceDoubleClick = false;
        }
      } else {
        const {data:res} = await this.$http.put(`footService/orgId/${this.orgId}/orgLevel/${this.orgLevel}`,this.footService);
        if (res.code === 200){
          this.$message.success(res.msg);
          this.createServiceDoubleClick = false;
        } else {
          this.createServiceDoubleClick = false;
        }
      }
      await this.loadService();
      this.serviceDialogVisible = false;
    },
    serviceCancel(){
      this.serviceDialogVisible = false;
    },
    deleteServiceBox(data){
      this.deleteServiceId = data.id;
      this.deleteServiceName = data.serviceName;
      this.$confirm('此操作将永久删除该服务, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.deleteFootService();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    async deleteFootService(){
      const {data:res} = await this.$http.delete(`footService/footServiceName/${this.deleteServiceName}/orgId/${this.orgId}/orgLevel/${this.orgLevel}`);
      if (res.code === 200){
        this.$message.success(res.msg);
      } else {
        this.$message.success(res.msg);
      }
      await this.loadService();
    },
    async loadService(){
      const {data:res} = await this.$http.get(`footService/serveTypeId/${this.serveTypeData.id}/orgId/${this.serveTypeData.orgId}`);
      if (res.code === 200){
        this.serveList = res.data;
      }
    },
    packageFormatter(row){
      let value = "";
      for (let i = 0; i < this.isPackageText.length; i++){
        let item = this.isPackageText[i];
        if (row.isPackage === item.isPackage) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    //拖拽保存方法
    async handleDrop(draggingNode, dropNode, dropType){
      const paramData = [];
      // 当拖拽类型不为inner,说明只是同级或者跨级排序，只需要寻找目标节点的父ID，获取其对象以及所有的子节点，并为子节点设置当前对象的ID为父ID即可
      // 当拖拽类型为inner，说明拖拽节点成为了目标节点的子节点，只需要获取目标节点对象即可
      const data = dropType !== "inner" ? dropNode.parent.data : dropNode.data;
      const nodeData = dropNode.level === 1 && dropType !== "inner" ? data : data.children;
      // 设置父ID,当level为1说明在第一级，pid为空
      nodeData.forEach(element => {
        element.pid = dropNode.level === 1 ? "" : data.id;
      });
      nodeData.forEach((element, i) => {
        const dept = {
          deptId: element.id,
          parentDeptId: element.pid,
          order: i
        };
        paramData.push(dept);
      });
      // 得到这次操作需要变更的数据范围，请求后台批量处理即可...
      const {data:res} =  await this.$http.put(`footServeType/footServeTypeListOrder/orgId/${this.serveTypeData.orgId}/orgLevel/${this.orgLevel}`, paramData);
      if (res.code === 200){
        this.productTypeList = res.data;
      }
    },
    allowDrop(moveNode, inNode, type) {
      if(moveNode.level=== 1 && inNode.level===1){
        // 四种情况
        if(moveNode.nextSibling === undefined){
          return type === 'prev';
        } else if(inNode.nextSibling === undefined){
          return type === 'next';
        } else if(moveNode.nextSibling.id !== inNode.id){
          return type === 'prev';
        } else {
          return type === 'next';
        }
      }
      //是否为同级下的子节点
      if(moveNode.level === 2 && inNode.level === 2 && moveNode.parent.id === inNode.parent.id){
        // 四种情况
        if(moveNode.nextSibling === undefined){
          return type === 'prev';
        } else if(inNode.nextSibling === undefined){
          return type === 'next';
        } else if(moveNode.nextSibling.id !== inNode.id){
          return type === 'prev';
        }else{
          return type === 'next';
        }
      }
      //是否为同级下的子节点
      if(moveNode.level === 3 && inNode.level === 3 && moveNode.parent.id === inNode.parent.id){
        // 四种情况
        if(moveNode.nextSibling === undefined){
          return type === 'prev';
        } else if(inNode.nextSibling === undefined){
          return type === 'next';
        } else if(moveNode.nextSibling.id !== inNode.id){
          return type === 'prev';
        }else{
          return type === 'next';
        }
      }
    },
    async checkServiceName(){
      const {data:res} =  await this.$http.get(`footService/checkName/${this.footService.serviceName}`);
      if (res.data > 0){
        this.$message.warning("该服务已经存在！");
        this.existName = true;
      } else {
        this.existName = false;
      }
    }
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadOrg();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 100vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 100vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  flex: 1;
  margin: 10px 0;
  width: 30%;
}
.left_inner_con{
  width: 100%;
  height: 90vh;
  overflow-y: auto;
  margin-right: 10px;
}
.left_inner_con::-webkit-scrollbar {
  width: 0 !important
}
.table_container{
  flex: 1;
  width: 70%;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/FootServices.vue